import { RecursiveCount } from './types'

export function recursiveCountSum({
  count = 0,
  counts = [],
}: RecursiveCount): number {
  return (
    counts.reduce((sum, badges) => sum + recursiveCountSum(badges), 0) + count
  )
}
